var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpageReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 304,
    viewBox: "0 0 502 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7482_176498)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7482_176498)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 10,
    width: 399.375,
    height: 284,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 10,
    width: 400,
    height: 22,
    fill: "#39665F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 262,
    transform: "translate(57 32)",
    fill: "#527F77"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 32,
    width: 64,
    height: 18,
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 50,
    width: 64,
    height: 18,
    fill: "#ADD53A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 68,
    width: 64,
    height: 18,
    fill: "#023731"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 86,
    width: 64,
    height: 18,
    fill: "#023731"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 104,
    width: 64,
    height: 18,
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 122,
    width: 64,
    height: 18,
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 140,
    width: 64,
    height: 18,
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 158,
    width: 64,
    height: 18,
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 176,
    width: 64,
    height: 18,
    fill: "#204E47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 38,
    width: 57,
    height: 14,
    rx: 1,
    fill: "#ADD53A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 58,
    width: 315,
    height: 62,
    rx: 2,
    fill: "#DBE9E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 64,
    width: 71.25,
    height: 50,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.25,
    y: 64,
    width: 71.25,
    height: 50,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.5,
    y: 64,
    width: 71.25,
    height: 50,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.75,
    y: 64,
    width: 71.25,
    height: 50,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7482_176498)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 126,
    width: 315,
    height: 156,
    rx: 1,
    fill: "#DBE9E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 126,
    width: 315,
    height: 12,
    fill: "#474741"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 138,
    width: 315,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 150,
    width: 315,
    height: 12,
    fill: "#F3F8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 162,
    width: 315,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 174,
    width: 315,
    height: 12,
    fill: "#F3F8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 186,
    width: 315,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 198,
    width: 315,
    height: 12,
    fill: "#F3F8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 210,
    width: 315,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 222,
    width: 315,
    height: 12,
    fill: "#F3F8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 234,
    width: 315,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 246,
    width: 315,
    height: 12,
    fill: "#F3F8F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 258,
    width: 315,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 270,
    width: 315,
    height: 12,
    fill: "#F3F8F7"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 152H27",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 240H27",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86H27",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59H27",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M476 45H446",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M486 21H456",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M476 86H446",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M476 204H446",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3935 245V243.886L17.8388 240.317C18.2067 239.929 18.5099 239.589 18.7486 239.298C18.9905 239.003 19.1712 238.723 19.2905 238.457C19.4098 238.192 19.4695 237.911 19.4695 237.612C19.4695 237.274 19.3899 236.982 19.2308 236.737C19.0717 236.489 18.8546 236.298 18.5795 236.165C18.3045 236.03 17.9946 235.962 17.6499 235.962C17.2853 235.962 16.9671 236.036 16.6953 236.185C16.4235 236.335 16.2147 236.545 16.0689 236.817C15.9231 237.089 15.8501 237.407 15.8501 237.771H14.3835C14.3835 237.152 14.526 236.61 14.8111 236.146C15.0961 235.682 15.4872 235.322 15.9844 235.067C16.4815 234.808 17.0466 234.679 17.6797 234.679C18.3194 234.679 18.8828 234.807 19.37 235.062C19.8606 235.314 20.2434 235.658 20.5185 236.096C20.7936 236.53 20.9311 237.021 20.9311 237.567C20.9311 237.945 20.8598 238.315 20.7173 238.676C20.5781 239.037 20.3345 239.44 19.9865 239.884C19.6385 240.325 19.1546 240.86 18.5348 241.49L16.5114 243.608V243.683H21.0952V245H14.3935Z",
    fill: "#0B1B29"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49059 157.139C3.86748 157.139 3.30735 157.02 2.81019 156.781C2.31635 156.539 1.92193 156.208 1.62695 155.787C1.33197 155.366 1.17454 154.885 1.15465 154.345H2.64613C2.68259 154.783 2.87648 155.142 3.22781 155.424C3.57913 155.706 4.00006 155.847 4.49059 155.847C4.88169 155.847 5.22804 155.757 5.52965 155.578C5.83458 155.396 6.07321 155.146 6.24556 154.827C6.42122 154.509 6.50906 154.146 6.50906 153.739C6.50906 153.324 6.41957 152.955 6.24059 152.63C6.06161 152.305 5.81469 152.05 5.49982 151.864C5.18827 151.679 4.83031 151.584 4.42596 151.581C4.11772 151.581 3.80782 151.634 3.49627 151.74C3.18472 151.846 2.93282 151.985 2.74059 152.158L1.33363 151.949L1.90536 146.818H7.50337V148.136H3.18306L2.85991 150.984H2.91957C3.11843 150.792 3.38192 150.631 3.71005 150.502C4.04149 150.373 4.39613 150.308 4.77397 150.308C5.39376 150.308 5.94561 150.456 6.42951 150.751C6.91673 151.046 7.29954 151.448 7.57795 151.959C7.85967 152.466 7.99888 153.049 7.99556 153.709C7.99888 154.368 7.84973 154.957 7.54812 155.474C7.24982 155.991 6.83552 156.398 6.30522 156.697C5.77823 156.992 5.17335 157.139 4.49059 157.139ZM11.8961 155.608L11.8216 156.15C11.7718 156.548 11.6873 156.962 11.568 157.393C11.452 157.827 11.331 158.23 11.2051 158.601C11.0824 158.972 10.9814 159.267 10.9018 159.486H9.84783C9.89092 159.28 9.95058 159.002 10.0268 158.651C10.103 158.303 10.1776 157.913 10.2505 157.482C10.3234 157.051 10.3781 156.612 10.4146 156.165L10.4643 155.608H11.8961ZM17.574 157.139C16.8614 157.139 16.2317 157.017 15.6848 156.771C15.1413 156.526 14.7154 156.188 14.4071 155.757C14.0989 155.326 13.9464 154.836 13.9498 154.286C13.9464 153.855 14.0343 153.459 14.2132 153.097C14.3955 152.733 14.6425 152.429 14.954 152.188C15.2656 151.942 15.6136 151.786 15.998 151.72V151.661C15.4909 151.538 15.0849 151.266 14.78 150.845C14.4751 150.424 14.3243 149.94 14.3276 149.393C14.3243 148.873 14.4618 148.409 14.7402 148.001C15.022 147.59 15.4081 147.267 15.8986 147.032C16.3891 146.797 16.9476 146.679 17.574 146.679C18.1938 146.679 18.7473 146.798 19.2346 147.037C19.7251 147.272 20.1112 147.595 20.3929 148.006C20.6747 148.414 20.8172 148.876 20.8205 149.393C20.8172 149.94 20.6614 150.424 20.3532 150.845C20.0449 151.266 19.6439 151.538 19.15 151.661V151.72C19.5312 151.786 19.8742 151.942 20.1792 152.188C20.4874 152.429 20.7327 152.733 20.915 153.097C21.1006 153.459 21.195 153.855 21.1983 154.286C21.195 154.836 21.0392 155.326 20.731 155.757C20.4228 156.188 19.9952 156.526 19.4483 156.771C18.9048 157.017 18.28 157.139 17.574 157.139ZM17.574 155.881C17.995 155.881 18.3596 155.812 18.6678 155.673C18.976 155.53 19.2147 155.333 19.3837 155.081C19.5527 154.826 19.6389 154.527 19.6422 154.186C19.6389 153.831 19.5461 153.518 19.3638 153.246C19.1848 152.975 18.9412 152.761 18.633 152.605C18.3248 152.449 17.9718 152.371 17.574 152.371C17.173 152.371 16.8167 152.449 16.5051 152.605C16.1936 152.761 15.9483 152.975 15.7694 153.246C15.5904 153.518 15.5025 153.831 15.5059 154.186C15.5025 154.527 15.5837 154.826 15.7495 155.081C15.9185 155.333 16.1588 155.53 16.4703 155.673C16.7819 155.812 17.1498 155.881 17.574 155.881ZM17.574 151.143C17.9121 151.143 18.2121 151.076 18.4739 150.94C18.7357 150.804 18.9412 150.615 19.0904 150.373C19.2428 150.131 19.3207 149.848 19.324 149.523C19.3207 149.205 19.2445 148.926 19.0953 148.688C18.9495 148.449 18.7457 148.265 18.4838 148.136C18.222 148.003 17.9187 147.937 17.574 147.937C17.2227 147.937 16.9145 148.003 16.6493 148.136C16.3875 148.265 16.1837 148.449 16.0378 148.688C15.892 148.926 15.8207 149.205 15.824 149.523C15.8207 149.848 15.8936 150.131 16.0428 150.373C16.1919 150.615 16.3974 150.804 16.6593 150.94C16.9244 151.076 17.2293 151.143 17.574 151.143Z",
    fill: "#0B1B29"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56143 91.1392C4.10736 91.1326 3.65992 91.0497 3.21911 90.8906C2.78161 90.7315 2.38388 90.4664 2.02592 90.0952C1.66797 89.724 1.38127 89.2251 1.16584 88.5987C0.953717 87.9723 0.847656 87.1901 0.847656 86.2521C0.847656 85.3639 0.935488 84.575 1.11115 83.8857C1.29013 83.1963 1.54699 82.6146 1.88175 82.1406C2.2165 81.6634 2.62086 81.3004 3.09482 81.0518C3.56877 80.8033 4.10073 80.679 4.6907 80.679C5.29723 80.679 5.83582 80.7983 6.30646 81.0369C6.77711 81.2756 7.15826 81.6054 7.44993 82.0263C7.74491 82.4472 7.93217 82.9261 8.01172 83.4631H6.49538C6.39264 83.0388 6.1888 82.6925 5.88388 82.424C5.57895 82.1555 5.18123 82.0213 4.6907 82.0213C3.94496 82.0213 3.36328 82.3461 2.94567 82.9957C2.53137 83.6454 2.32256 84.5485 2.31925 85.7053H2.39382C2.56948 85.4169 2.78492 85.1716 3.04013 84.9695C3.29865 84.764 3.587 84.6065 3.90518 84.4972C4.22668 84.3845 4.56475 84.3281 4.91939 84.3281C5.50935 84.3281 6.04297 84.4723 6.52024 84.7607C7.00083 85.0457 7.38364 85.4401 7.66868 85.9439C7.95372 86.4477 8.09624 87.0244 8.09624 87.674C8.09624 88.3236 7.94875 88.9119 7.65376 89.4389C7.3621 89.9659 6.95111 90.3835 6.42081 90.6918C5.89051 90.9967 5.27072 91.1458 4.56143 91.1392ZM4.55646 89.8466C4.94756 89.8466 5.29723 89.7505 5.60547 89.5582C5.91371 89.366 6.15732 89.1075 6.33629 88.7827C6.51527 88.4579 6.60476 88.0949 6.60476 87.6939C6.60476 87.3028 6.51693 86.9465 6.34126 86.625C6.16892 86.3035 5.93028 86.0483 5.62536 85.8594C5.32375 85.6705 4.97905 85.576 4.59126 85.576C4.29628 85.576 4.02285 85.6323 3.77095 85.745C3.52237 85.8577 3.30362 86.0135 3.1147 86.2124C2.92578 86.4112 2.77663 86.6399 2.66726 86.8984C2.5612 87.1536 2.50817 87.4238 2.50817 87.7088C2.50817 88.09 2.596 88.4429 2.77166 88.7678C2.95064 89.0926 3.19425 89.3544 3.50249 89.5533C3.81404 89.7488 4.16536 89.8466 4.55646 89.8466ZM11.8961 89.608L11.8216 90.1499C11.7718 90.5476 11.6873 90.9619 11.568 91.3928C11.452 91.8269 11.331 92.2296 11.2051 92.6009C11.0824 92.9721 10.9814 93.267 10.9018 93.4858H9.84783C9.89092 93.2803 9.95058 93.0019 10.0268 92.6506C10.103 92.3026 10.1776 91.9131 10.2505 91.4822C10.3234 91.0514 10.3781 90.6122 10.4146 90.1648L10.4643 89.608H11.8961ZM17.574 91.1392C16.8614 91.1392 16.2317 91.0166 15.6848 90.7713C15.1413 90.526 14.7154 90.188 14.4071 89.7571C14.0989 89.3262 13.9464 88.8357 13.9498 88.2855C13.9464 87.8546 14.0343 87.4586 14.2132 87.0973C14.3955 86.7327 14.6425 86.4295 14.954 86.1875C15.2656 85.9422 15.6136 85.7865 15.998 85.7202V85.6605C15.4909 85.5379 15.0849 85.2661 14.78 84.8452C14.4751 84.4242 14.3243 83.9403 14.3276 83.3935C14.3243 82.8731 14.4618 82.4091 14.7402 82.0014C15.022 81.5904 15.4081 81.2673 15.8986 81.032C16.3891 80.7966 16.9476 80.679 17.574 80.679C18.1938 80.679 18.7473 80.7983 19.2346 81.0369C19.7251 81.2723 20.1112 81.5954 20.3929 82.0064C20.6747 82.4141 20.8172 82.8764 20.8205 83.3935C20.8172 83.9403 20.6614 84.4242 20.3532 84.8452C20.0449 85.2661 19.6439 85.5379 19.15 85.6605V85.7202C19.5312 85.7865 19.8742 85.9422 20.1792 86.1875C20.4874 86.4295 20.7327 86.7327 20.915 87.0973C21.1006 87.4586 21.195 87.8546 21.1983 88.2855C21.195 88.8357 21.0392 89.3262 20.731 89.7571C20.4228 90.188 19.9952 90.526 19.4483 90.7713C18.9048 91.0166 18.28 91.1392 17.574 91.1392ZM17.574 89.8814C17.995 89.8814 18.3596 89.8118 18.6678 89.6726C18.976 89.5301 19.2147 89.3329 19.3837 89.081C19.5527 88.8258 19.6389 88.5275 19.6422 88.1861C19.6389 87.8314 19.5461 87.5182 19.3638 87.2464C19.1848 86.9747 18.9412 86.7609 18.633 86.6051C18.3248 86.4493 17.9718 86.3714 17.574 86.3714C17.173 86.3714 16.8167 86.4493 16.5051 86.6051C16.1936 86.7609 15.9483 86.9747 15.7694 87.2464C15.5904 87.5182 15.5025 87.8314 15.5059 88.1861C15.5025 88.5275 15.5837 88.8258 15.7495 89.081C15.9185 89.3329 16.1588 89.5301 16.4703 89.6726C16.7819 89.8118 17.1498 89.8814 17.574 89.8814ZM17.574 85.1435C17.9121 85.1435 18.2121 85.0755 18.4739 84.9396C18.7357 84.8037 18.9412 84.6148 19.0904 84.3729C19.2428 84.1309 19.3207 83.8475 19.324 83.5227C19.3207 83.2045 19.2445 82.9261 19.0953 82.6875C18.9495 82.4489 18.7457 82.2649 18.4838 82.1357C18.222 82.0031 17.9187 81.9368 17.574 81.9368C17.2227 81.9368 16.9145 82.0031 16.6493 82.1357C16.3875 82.2649 16.1837 82.4489 16.0378 82.6875C15.892 82.9261 15.8207 83.2045 15.824 83.5227C15.8207 83.8475 15.8936 84.1309 16.0428 84.3729C16.1919 84.6148 16.3974 84.8037 16.6593 84.9396C16.9244 85.0755 17.2293 85.1435 17.574 85.1435Z",
    fill: "#0B1B29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15447 64L7.59908 55.2102V55.1357H2.45845V53.8182H9.18999V55.1804L4.7603 64H3.15447ZM11.6227 62.608L11.5481 63.1499C11.4984 63.5476 11.4139 63.9619 11.2946 64.3928C11.1786 64.8269 11.0576 65.2296 10.9316 65.6009C10.809 65.9721 10.7079 66.267 10.6284 66.4858H9.5744C9.61748 66.2803 9.67714 66.0019 9.75337 65.6506C9.8296 65.3026 9.90418 64.9131 9.9771 64.4822C10.05 64.0514 10.1047 63.6122 10.1412 63.1648L10.1909 62.608H11.6227ZM17.4647 53.679C17.9187 53.6823 18.3662 53.7652 18.807 53.9276C19.2478 54.09 19.6455 54.3551 20.0002 54.723C20.3581 55.0909 20.6432 55.5881 20.8553 56.2145C21.0707 56.8376 21.1801 57.6132 21.1834 58.5412C21.1834 59.4328 21.0939 60.2266 20.915 60.9226C20.736 61.6153 20.4791 62.2003 20.1444 62.6776C19.8129 63.1548 19.4102 63.5178 18.9363 63.7663C18.4623 64.0149 17.9287 64.1392 17.3354 64.1392C16.7289 64.1392 16.1903 64.0199 15.7196 63.7812C15.249 63.5426 14.8662 63.2128 14.5712 62.7919C14.2762 62.3677 14.0923 61.8804 14.0194 61.3303H15.5357C15.6351 61.7678 15.8373 62.1224 16.1422 62.3942C16.4505 62.6626 16.8482 62.7969 17.3354 62.7969C18.0811 62.7969 18.6628 62.4721 19.0804 61.8224C19.498 61.1695 19.7085 60.258 19.7118 59.0881H19.6323C19.4599 59.3731 19.2445 59.6184 18.986 59.8239C18.7308 60.0294 18.4441 60.1884 18.1259 60.3011C17.8077 60.4138 17.468 60.4702 17.1067 60.4702C16.5201 60.4702 15.9864 60.326 15.5059 60.0376C15.0253 59.7493 14.6425 59.3532 14.3574 58.8494C14.0724 58.3456 13.9299 57.7706 13.9299 57.1243C13.9299 56.4813 14.0757 55.898 14.3674 55.3743C14.6623 54.8506 15.0733 54.4363 15.6003 54.1314C16.1306 53.8232 16.7521 53.6723 17.4647 53.679ZM17.4696 54.9716C17.0819 54.9716 16.7322 55.0677 16.4206 55.2599C16.1124 55.4489 15.8688 55.7057 15.6898 56.0305C15.5108 56.352 15.4213 56.71 15.4213 57.1044C15.4213 57.4988 15.5075 57.8568 15.6799 58.1783C15.8555 58.4964 16.0942 58.75 16.3958 58.9389C16.7007 59.1245 17.0487 59.2173 17.4398 59.2173C17.7315 59.2173 18.0033 59.161 18.2551 59.0483C18.507 58.9356 18.7275 58.7798 18.9164 58.581C19.1053 58.3788 19.2528 58.1501 19.3588 57.8949C19.4649 57.6397 19.5179 57.3712 19.5179 57.0895C19.5179 56.715 19.4284 56.367 19.2495 56.0455C19.0738 55.724 18.8319 55.4654 18.5236 55.2699C18.2154 55.071 17.8641 54.9716 17.4696 54.9716Z",
    fill: "#0B1B29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M482.322 50L486.767 41.2102V41.1357H481.626V39.8182H488.358V41.1804L483.928 50H482.322ZM490.791 48.608L490.716 49.1499C490.666 49.5476 490.582 49.9619 490.463 50.3928C490.347 50.8269 490.226 51.2296 490.1 51.6009C489.977 51.9721 489.876 52.267 489.796 52.4858H488.742C488.785 52.2803 488.845 52.0019 488.921 51.6506C488.998 51.3026 489.072 50.9131 489.145 50.4822C489.218 50.0514 489.273 49.6122 489.309 49.1648L489.359 48.608H490.791ZM496.633 39.679C497.087 39.6823 497.534 39.7652 497.975 39.9276C498.416 40.09 498.814 40.3551 499.168 40.723C499.526 41.0909 499.811 41.5881 500.023 42.2145C500.239 42.8376 500.348 43.6132 500.351 44.5412C500.351 45.4328 500.262 46.2266 500.083 46.9226C499.904 47.6153 499.647 48.2003 499.312 48.6776C498.981 49.1548 498.578 49.5178 498.104 49.7663C497.63 50.0149 497.097 50.1392 496.503 50.1392C495.897 50.1392 495.358 50.0199 494.888 49.7812C494.417 49.5426 494.034 49.2128 493.739 48.7919C493.444 48.3677 493.26 47.8804 493.187 47.3303H494.704C494.803 47.7678 495.005 48.1224 495.31 48.3942C495.618 48.6626 496.016 48.7969 496.503 48.7969C497.249 48.7969 497.831 48.4721 498.248 47.8224C498.666 47.1695 498.876 46.258 498.88 45.0881H498.8C498.628 45.3731 498.412 45.6184 498.154 45.8239C497.899 46.0294 497.612 46.1884 497.294 46.3011C496.976 46.4138 496.636 46.4702 496.275 46.4702C495.688 46.4702 495.154 46.326 494.674 46.0376C494.193 45.7493 493.81 45.3532 493.525 44.8494C493.24 44.3456 493.098 43.7706 493.098 43.1243C493.098 42.4813 493.244 41.898 493.535 41.3743C493.83 40.8506 494.241 40.4363 494.768 40.1314C495.299 39.8232 495.92 39.6723 496.633 39.679ZM496.638 40.9716C496.25 40.9716 495.9 41.0677 495.589 41.2599C495.28 41.4489 495.037 41.7057 494.858 42.0305C494.679 42.352 494.589 42.71 494.589 43.1044C494.589 43.4988 494.675 43.8568 494.848 44.1783C495.023 44.4964 495.262 44.75 495.564 44.9389C495.869 45.1245 496.217 45.2173 496.608 45.2173C496.899 45.2173 497.171 45.161 497.423 45.0483C497.675 44.9356 497.895 44.7798 498.084 44.581C498.273 44.3788 498.421 44.1501 498.527 43.8949C498.633 43.6397 498.686 43.3712 498.686 43.0895C498.686 42.715 498.596 42.367 498.417 42.0455C498.242 41.724 498 41.4654 497.692 41.2699C497.383 41.071 497.032 40.9716 496.638 40.9716Z",
    fill: "#0B1B29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M485.524 91.1392C484.841 91.1392 484.232 91.0215 483.695 90.7862C483.161 90.5509 482.738 90.2244 482.427 89.8068C482.119 89.3859 481.953 88.8987 481.93 88.3452H483.491C483.511 88.6468 483.612 88.9086 483.794 89.1307C483.98 89.3494 484.222 89.5185 484.52 89.6378C484.818 89.7571 485.15 89.8168 485.514 89.8168C485.915 89.8168 486.27 89.7472 486.578 89.608C486.89 89.4687 487.133 89.2749 487.309 89.0263C487.485 88.7744 487.572 88.4844 487.572 88.1562C487.572 87.8149 487.485 87.5149 487.309 87.2564C487.137 86.9946 486.883 86.7891 486.548 86.6399C486.217 86.4908 485.816 86.4162 485.345 86.4162H484.485V85.1634H485.345C485.723 85.1634 486.054 85.0954 486.339 84.9595C486.628 84.8236 486.853 84.6347 487.016 84.3928C487.178 84.1475 487.259 83.8608 487.259 83.5327C487.259 83.2178 487.188 82.9444 487.045 82.7124C486.906 82.477 486.707 82.2931 486.449 82.1605C486.194 82.0279 485.892 81.9616 485.544 81.9616C485.213 81.9616 484.903 82.023 484.614 82.1456C484.329 82.2649 484.097 82.4373 483.918 82.6626C483.739 82.8847 483.643 83.1515 483.63 83.4631H482.143C482.16 82.9129 482.322 82.429 482.631 82.0114C482.942 81.5937 483.353 81.2673 483.864 81.032C484.374 80.7966 484.941 80.679 485.564 80.679C486.217 80.679 486.78 80.8066 487.254 81.0618C487.732 81.3137 488.099 81.6501 488.358 82.071C488.62 82.492 488.749 82.9527 488.746 83.4531C488.749 84.0232 488.59 84.5071 488.268 84.9048C487.95 85.3026 487.526 85.5694 486.996 85.7053V85.7848C487.672 85.8875 488.196 86.156 488.567 86.5902C488.941 87.0244 489.127 87.563 489.124 88.206C489.127 88.7661 488.971 89.2682 488.656 89.7124C488.345 90.1565 487.919 90.5062 487.379 90.7614C486.838 91.0133 486.22 91.1392 485.524 91.1392Z",
    fill: "#0B1B29"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M481.766 207.011V205.768L486.165 198.818H487.145V200.648H486.523L483.376 205.629V205.709H489.407V207.011H481.766ZM486.593 209V206.634L486.603 206.067V198.818H488.06V209H486.593Z",
    fill: "#0B1B29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M495.842 15.8182V26H494.301V17.3594H494.241L491.805 18.9503V17.4787L494.346 15.8182H495.842Z",
    fill: "#0B1B29"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7482_176498",
    x: 47,
    y: 0,
    width: 419.375,
    height: 304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7482_176498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7482_176498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7482_176498"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 10,
    width: 399.375,
    height: 284,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7482_176498"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 126,
    width: 315,
    height: 156,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpageReference);
export default __webpack_public_path__ + "static/media/webpage-reference.1da9f3c9b8e3186b453e4317227ff669.svg";
export { ForwardRef as ReactComponent };